export default __webpack_public_path__ + "static/houseSmallImg1-ba022fd2ac783cdb25ccb85e1b54bf9f.png";